import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dec-use-flex" }
const _hoisted_2 = { class: "context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "select-engine" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.1 Select Engine（选择引擎）")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择启动的虚幻引擎（现仅支持UE）的版本及选择要打开的项目/工程的文件。")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "设置完成，打开加载虚幻引擎并打开项目。")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "material" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.2 Material")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "（材质）")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "功能介绍：MAYA端材质浏览器。")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）选中模型，双击选中材质，将相应的材质渲染到模型。")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）在Shading Group节点的拓展属性下，可以看到虚幻引擎 实例化材质的属性（该功能与MAYA使用习惯一致。）")
], -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<h2><a id=\"lecel-map\"><span><span><span><span><span>3.3LeveI Map</span></span></span></span></span></a><span>（保存关卡）</span></h2><p><span>*</span><span>该功能为专业版功能</span></p><p><span>(1)<span>    </span></span><span>DEC</span><span>可以保存Level Map在MAYA的场景中，这样可以在下次打开MAYA场景的时候找到上次对应的Level Map。</span></p><p><span>(2)<span>    </span></span><span>点击“Level Map”，打开Level Map面板。</span></p>", 4)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<p><span>（3）在Level Map面板中：</span></p><p><span>①　</span><span>Saved Level Map</span><span>信息盒显示已保存的Level Map的相对路径。</span></p><p><span>②　</span><span>Current Level Map</span><span>信息盒显示当前连接的Level Map的相对路径。</span></p><p><span>③　</span><span>【Refresh】将当前连接的Level Map的相对路径刷新到“Current Level Map”信息盒中。</span></p><p><span>④　</span><span>【Save】将当前连接的Level Map的相对路径保存在“Saved Level Map”信息盒中，前提是这个路径已经显示在Current Level Map信息盒中。</span></p><p><span>⑤　</span><span>【Load】让虚幻引擎端加载“Current Level Map”信息盒中的Level Map。</span></p><p></p><h2><a id=\"render-settings\"><span>3.4 Render Settings</span></a><span>（渲染设置）</span></h2><p><span>功能介绍：DEC Render是用来渲染输出的工具，让MAYA像虚幻引擎一样简单的设置渲染参数以及输出。</span></p><p><span>（1）渲染视频设置面板。</span></p>", 10)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(1) 区域1内可以设置图像输出格式。若需要修改渲染视频分辨率需先设置MAYA本身输出的分辨率。")
], -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<p><span>(2) 区域2内可启用虚幻引擎默认压缩。</span></p><p><span>(3) 区域3内可设置视频输出目录。</span></p><p><span>(4) 区域4内可设置过场动画。</span></p><p><span>(5) 区域5内可设置序列。</span></p><p><span>(6) 设置完毕后点击Save保存设置。</span></p><h2><a id=\"render-range\"><span>3.5 Render range（渲染区间）</span></a></h2><p><span>功能介绍：设置动画的起始帧以及结束帧。</span></p>", 7)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Frame为动画的起始帧，End Frame为动画的结束帧。")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "render" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.6 Render（渲染）")
  ])
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "点击后将使用您在Render Settings面板中设置的参数渲染视频。")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "movie-render" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.7 Movie Render Queue（高质量渲染）")
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "功能描述：属于Render升级版本，可以更好的渲染高质量贴图。")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " （1）Render（Local） ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "点击后将使用您在Render Queue Setting面板中设置的参数进行渲染。")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " （2）Render Queue Setting")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "①点击后出现渲染设置界面")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "②可点击左上角Render添加需要渲染的关卡序列帧。选择后可点击相应Settings下的按钮进行渲染参数的设置。")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "③渲染参数初始仅展示基础参数，可通过点击左上角设置添加您需要调整的相应参数。")
], -1)
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<p><span>④设置完毕后点击Accept将把面板上的参数应用至相应的关卡序列帧上。</span></p><p><span>⑤也可通过点击右上角的Load/Save Preset可将面板上的参数加载或保存至资源管理器。</span></p><h2><a id=\"set-camera\"><span>3.8 Set Camera（同步镜头）</span></a></h2><p><span>功能介绍：设置镜头，将</span>MYMA<span>当前视角调整为虚幻引擎的当前视角。</span></p><h2><a id=\"export-scene\"><span><span><span><span><span>3.9 Export Scene</span></span></span></span></span></a><span>（导出场景）</span></h2><p><span>功能介绍：将MAYA中的场景、材质导出到虚幻引擎中。</span></p><p><span>（1）点击Export Scene出现选择存储地址弹窗，在弹出的窗口中，可选择想要保存的路径，并为其设置相应资产名称。</span></p>", 7)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "区域1内可设置存储的文件夹。")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "区域2内可编辑资产的名称。")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "设置完毕后点击确定即可保存。")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）导出的场景中没有灯光节点，需要在场景中自行创建灯光节点（导出的模型过小会导致在虚幻引擎中无法投射阴影）。")
], -1)
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<h2><a id=\"mesh-streaming\"><span>3.10 Use Cached GeometryExtractor（几何信息缓存）</span></a></h2><p><span>功能描述：对maya的几何信息提取进行缓存，性能可以得到提升。</span></p><p><span>(1) 选择 On（faster） DEC将对MAYA内的几何信息提取时进行缓存，但在某些情况会出现模型不同步的问题。</span></p><p><span>(2) 选中Off（默认）关闭缓存服务。</span></p><h2><a id=\"add-engine-asset\"><span>3.11 Delay Render（延迟渲染）</span></a></h2><p><span>功能描述：提升用户体验，DEC优化了算法策略，性能可以得到提升。</span></p><p><span>(1) 选择On（faster）即加速渲染过程，但同时会降低渲染效果质量，Off（默认）选中关闭加速服务。On（most faster）With Wireframe Lagged性能效果更好，但模型将落后线框1帧。</span></p><h2><a id=\"normal-tangent\"><span>3.12 Normal Tangent Streaming（流送法线、切线）</span></a></h2><p><span>功能描述：流送法线、切线信息传输开关，在需要的时候可以启用或禁用。</span></p><p><span>(1) 选择On（默认） DEC将会把模型的流送法线、切线信息一同传传输至虚幻引擎内。</span></p><p><span>(2) 选择Off（faster）DEC将关不流送法线、切线信息传输，用于提高性能。</span></p><h2><a id=\"add-engine-transform\"><span>3.13 Create Engine Transform Delegate</span></a><span>（添加DEC节点代理）</span></h2><p><span>*</span><span>该功能为专业版功能</span></p><p><span>功能介绍：在MAYA端操作虚幻引擎资产的平移、缩放及旋转等。</span></p><p><span>（1）在MAYA端创建并选中一个Locator后，点击Add Engine Transform Delegate，将在虚幻引擎内创建一个名为“Engine Transform Actor”名称的Actor。</span></p>", 15)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）可在相应Actor下创建组件，相应Actor下的组件可在MAYA端内进行任意Transform节点的位移、旋转、缩放操作。")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "manage-engine-transform" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "3.14 Manage Engine Transform Delegate")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "（DEC节点列表）")
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "功能介绍："),
  /*#__PURE__*/_createTextVNode("Engine Transform View"),
  /*#__PURE__*/_createElementVNode("span", null, "窗口。")
], -1)
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<p><b><span>Transform Delegate List</span></b></p><p><span>展示MAYA内通过Create Engine Asset Node和Create Engine Transform Delegate创建的虚幻引擎资产。</span></p><p><b><span>MAYA Model List</span></b></p><p><span>展示MAYA场景内全部对象。</span></p><h2><a id=\"create-engine-node\"><span>3.15 Create Engine Asset Node（添加引擎节点）</span></a></h2><p><span>*</span><span>该功能为专业版功能</span></p><p><span>功能描述：可在MAYA端内添加虚幻引擎内的资产。</span></p><p><span>（1）点击后出现资产选择窗口。</span></p>", 8)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "①区域1内可选择资产的文件夹")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "②区域2内可展示文件夹内的资产，双击资产即可将相应的资产添加至的MAYA场景中。")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "添加资产后可在MAYA端内设置相应资产在虚幻引擎内的基础属性。")
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "set-asset-path" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.16 Set Engine Asset Path（引擎资产路径）")
  ])
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "功能介绍：用于修改通过Create Engine Asset Node创建的引擎节点。")
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "about" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.17 About Us（关于我们）")
  ])
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "功能介绍：关于"),
  /*#__PURE__*/_createTextVNode("DEC"),
  /*#__PURE__*/_createElementVNode("span", null, "的软件介绍。")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-use-maya" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "3.18 DEC支持MAYA+UE版本")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_89 = { class: "name" }
const _hoisted_90 = { class: "version" }
const _hoisted_91 = { class: "version" }
const _hoisted_92 = { class: "version" }
const _hoisted_93 = { class: "version" }
const _hoisted_94 = { class: "version" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DecUseZh',
  setup(__props) {

const versionData = [
  {
    name: "MAYA：",
    version1: "2017",
    version2: "2018",
    version3: "2019",
    version4: "2020",
    version5: "2022",
    version5: "2023",
  },
  {
    name: "UE：",
    version1: "4.26",
    version2: "4.27",
    version3: "5.0",
    version4: "",
    version5: "",
  },
];
const imageList = {
  image1: require("../../assets/document-images/bdf3873b77b84aaf932d22fd54e4dfaf.jpg"),
  image2: require("../../assets/document-images/2fd8f307aae343ee83655bd60995fcc0.jpg"),
  image3: require("../../assets/document-images/14d428947f7649e1897ff35be8dec17d.jpg"),
  image4: require("../../assets/document-images/882e194154f84ef5a5e4ffa37fde36ea.jpg"),
  image5: require("../../assets/document-images/531fa6820e90460b9f82e84c7f20d6e4.jpg"),
  image6: require("../../assets/document-images/3-4-1.png"),
  image7: require("../../assets/document-images/3-5-1.png"),
  image3_7: require("../../assets/document-images/3-7-1.png"),
  image3_7_2: require("../../assets/document-images/3-7-2.png"),
  image3_7_3: require("../../assets/document-images/3-7-3.png"),
  image3_7_4: require("../../assets/document-images/3-7-4.png"),
  image8: require("../../assets/document-images/c7ebf6134dd64784a359ab7e2e70875c.jpg"),
  image9: require("../../assets/document-images/2586d470cff7498b8127a827162ffbab.jpg"),
  image10: require("../../assets/document-images/d089e3a510bc4d38aa1e7613a6d10d32.jpg"),
  image11: require("../../assets/document-images/015424af979845229cdcf29bebc00333.jpg"),
  image12: require("../../assets/document-images/b3625935edff4a4f877da8e1e2044a53.jpg"),
  image13: require("../../assets/document-images/f72459a2626c4809a5753178369e6bb0.jpg"),
  image14: require("../../assets/document-images/18741ba498694afaa721aeddf5ee7d40.jpg"),
  image15: require("../../assets/document-images/4d4c0563e9944b14b228d571460ff71e.jpg"),
  image16: require("../../assets/document-images/2f7f9d24f2c443e99d5a9dd4e78e185b.jpg"),
  image17: require("../../assets/document-images/68b8369b7c9e48148befc1d702d3390a.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _hoisted_4,
          _createElementVNode("span", null, [
            _createVNode(_component_el_image, {
              src: imageList.image1,
              "preview-src-list": [imageList.image1],
              fit: "contain"
            }, null, 8, ["src", "preview-src-list"])
          ])
        ])
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image2,
          "preview-src-list": [imageList.image2],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_10,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3,
          "preview-src-list": [imageList.image3],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_11,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image4,
          "preview-src-list": [imageList.image4],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_15,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image5,
          "preview-src-list": [imageList.image5],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_25,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image6,
          "preview-src-list": [imageList.image6],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_26,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image7,
          "preview-src-list": [imageList.image7],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_33,
      _hoisted_34,
      _hoisted_35,
      _hoisted_36,
      _hoisted_37,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7,
          "preview-src-list": [imageList.image3_7],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_38,
      _hoisted_39,
      _hoisted_40,
      _hoisted_41,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_2,
          "preview-src-list": [imageList.image3_7_2],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_42,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_3,
          "preview-src-list": [imageList.image3_7_3],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_43,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_4,
          "preview-src-list": [imageList.image3_7_4],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_44,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image9,
          "preview-src-list": [imageList.image9],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_51,
      _hoisted_52,
      _hoisted_53,
      _hoisted_54,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image10,
          "preview-src-list": [imageList.image10],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_55,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image14,
          "preview-src-list": [imageList.image14],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image15,
          "preview-src-list": [imageList.image15],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_70,
      _hoisted_71,
      _hoisted_72,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image16,
          "preview-src-list": [imageList.image16],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_73,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image12,
          "preview-src-list": [imageList.image12],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_81,
      _hoisted_82,
      _hoisted_83,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image13,
          "preview-src-list": [imageList.image13],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_84,
      _hoisted_85,
      _hoisted_86,
      _hoisted_87,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image17,
          "preview-src-list": [imageList.image17],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_88,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(versionData, (item) => {
        return _createElementVNode("div", {
          key: item.name,
          class: "version-flex"
        }, [
          _createElementVNode("span", _hoisted_89, _toDisplayString(item.name), 1),
          _createElementVNode("span", _hoisted_90, _toDisplayString(item.version1), 1),
          _createElementVNode("span", _hoisted_91, _toDisplayString(item.version2), 1),
          _createElementVNode("span", _hoisted_92, _toDisplayString(item.version3), 1),
          _createElementVNode("span", _hoisted_93, _toDisplayString(item.version4), 1),
          _createElementVNode("span", _hoisted_94, _toDisplayString(item.version5), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})